import { com } from '@eidu/form'
import SemanticLinkKey = com.eidu.sharedlib.entity.analytics.SemanticLinkKey
import SemanticLinkKeyConfiguration = com.eidu.sharedlib.entity.analytics.SemanticLinkKeyConfiguration
import EntityTypeKind = com.eidu.sharedlib.entity.type.EntityTypeKind
import FieldType = com.eidu.sharedlib.entity.field.FieldType

type SemanticLinkConfig = {
  title: string
  key: SemanticLinkKey
  toTypeKind: EntityTypeKind | null
  duplicatesAllowed: boolean
  fieldType: FieldType
}

export const fromPredefined = (config: SemanticLinkKeyConfiguration): SemanticLinkConfig => ({
  title: config.title,
  key: config.key,
  toTypeKind: config.toTypeKind ?? null,
  duplicatesAllowed: config.duplicatesAllowed,
  fieldType: config.fieldType,
})

export default SemanticLinkConfig
